import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpGridDirective } from './help-grid.directive';

@NgModule({
  declarations: [
    HelpGridDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    HelpGridDirective
  ]
})
export class HelpGridModule { }
